module.exports = __webpack_public_path__ + "img/tab0.6bf15bad.png";